export default "__VITE_ASSET__DWMttwCd__"